import * as _ from 'lodash'

import Component from "vue-class-component";

import { ReactiveVue } from "@skinsoft/reactive-vue";

import { Item } from "@skinsoft/entity";
import { ItemEditScreen } from "../item-edit-screen";

import { ItemDataStore } from "@skinsoft/entity";

import { Routes } from "../../../router";

@Component({
    components: {
        itemEditScreen: ItemEditScreen
    },
    props: ['itemId'],
    template: require('./solo-item-edit-screen.html'),
})
export class SoloItemEditScreen extends ReactiveVue {
    
    public item: Item = null as any;
    
    private itemId: string;

    private $itemDataStore: ItemDataStore;

    private induceUpdate: boolean = false;

    public mounted() {
        this.subscribeTo(
            this.$itemDataStore.fetchOne(this.itemId),
            item => this.item = item
        )
    }

    public changeMediaId(idChange) {
        this.$set(this.item.associatedMedias, 'first', idChange.newMediaId)
        this.$set(this.item.associatedMedias, 'medias', _.concat(this.item.associatedMedias.medias.filter(m => m !== idChange.oldMediaId && m !== idChange.newMediaId), [idChange.newMediaId]))
        this.induceUpdate = true
    }

    public updateDone() {
        this.induceUpdate = false
        if (this.item?.associatedMedias?.first) {
            this.$set(this.item.associatedMedias, 'illustratedNote', true)
        }
    }

    public closeItemScreen() {
        let route = Routes.NEW_ITEMS
        if (window.navigator.onLine) {
            route = Routes.AUDIT_HOME
        }
        this.$router.push({name: route})
    }
}